import Sharing from '../../shared/ui/Sharing/Sharing';
import cls from './Final.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../shared/redux/store';
import { setEndGame, setPage } from '../../shared/redux/pages/slice';
import { Pages } from '../../shared/redux/pages/types';
import { useEffect, useMemo } from 'react';
import buttonMp3 from '../../shared/assets/sound/button_2.mp3';
import badMp3 from '../../shared/assets/sound/final_bad_1.mp3';
import goodMp3 from '../../shared/assets/sound/final_good_1.mp3';
import bestMp3 from '../../shared/assets/sound/final_best_1.mp3';
import { againGame } from '../../shared/redux/game/slice';
import { nextLevel, updateChildren } from '../../shared/redux/child/slice';
import { againHooks } from '../../shared/redux/hooks/slice';

const soundButton = new Howl({
  src: [buttonMp3],
});

const Final = () => {
  const dispatch = useDispatch();
  const children = useSelector((state: RootState) => state.children.children);
  const isSound = useSelector((state: RootState) => state.sound.isSound);
  const arrDiedLenght = useMemo(() => {
    return children.filter((el) => el.isDied).length;
  }, [children]);
  const headerArr = [
    'Кажется, тебе самому нужен наставник…',
    'Ты хорош, но…',
    'Кто супер-мега-крутой наставник? Ты!',
  ];
  const paragrArr = [
    'Может, это твой друг? Поделись игрой с ним.',
    '… не настолько, чтобы все добрались до вершины.',
    'Тебе под силу любое дело!',
  ];

  const getText = (type: string) => {
    if (arrDiedLenght === 6) {
      return type === 'h1' ? headerArr[0] : paragrArr[0];
    } else if (arrDiedLenght === 0) {
      return type === 'h1' ? headerArr[2] : paragrArr[2];
    } else {
      return type === 'h1' ? headerArr[1] : paragrArr[1];
    }
  };

  const getButtonText = () => {
    if (arrDiedLenght === 6) {
      return 'Лучше попробую еще раз';
    } else if (arrDiedLenght === 0) {
      return 'Подтвердить статус';
    } else {
      return 'Смогу лучше';
    }
  };

  const getClassName = () => {
    if (arrDiedLenght === 6) {
      return 'badFinal';
    } else if (arrDiedLenght === 0) {
      return 'bestFinal';
    } else {
      return 'goodFinal';
    }
  };

  useEffect(() => {
    if (isSound) {
      if (arrDiedLenght === 6) {
        const sound = new Howl({
          src: [badMp3],
        });
        sound.play();
      } else if (arrDiedLenght === 0) {
        const sound = new Howl({
          src: [bestMp3],
        });
        sound.play();
      } else {
        const sound = new Howl({
          src: [goodMp3],
        });
        sound.play();
      }
    }
  }, []);

  return (
    <div className={`${cls.Final} ${getClassName()}`}>
      <div className={cls.text_h}>
        <h1 className={cls.second_h}>{getText('h1')}</h1>
        <h1 className={cls.first_h}>{getText('h1')}</h1>
      </div>
      <div className={cls.text_p}>
        <p className={cls.second_p}>{getText('p')}</p>
        <p className={cls.first_p}>{getText('p')}</p>
      </div>
      <button
        onClick={() => {
          if (isSound) {
            soundButton.play();
          }
          dispatch(nextLevel());
          dispatch(againGame());
          dispatch(againHooks());
          dispatch(updateChildren());
          dispatch(setEndGame(false));
          dispatch(setPage(Pages.GAME));
        }}>
        <p>{getButtonText()}</p>
      </button>
      <Sharing />
    </div>
  );
};

export default Final;
